module.exports = new __parcel__URL__("level_9_tab_active.35e85d58.png").toString();